module.exports = __webpack_public_path__ + "media/images/icons/icon_panier_hover-92c1dfd99615e3b2c4fe4db14e2a1035.svg";